import PendingOffers from "./PendingOffers";

export default PendingOffers;
